export default __webpack_public_path__ + "static/media/imperfect-foods-dark.1379025d.svg";